import { backendService } from "../../../core/backend/services/backendService";

class SettingsService {
  getClientConfiguration() {
    return backendService
      .createBackendClient()
      .apiSettingsClientConfiguration();
  }

  getLegacySettings() {
    return backendService.createBackendClient().apiSettingsLegacySettings();
  }

  getErrorList() {
    return backendService.createBackendClient().apiSettingsErrorList();
  }
}

export const settingsService = new SettingsService();
